import { createReducer, on } from '@ngrx/store';
import * as plantActions from '../actions/plant.actions';
import { Plant } from '../../models/plant.model';

export interface PlantState {
  plants: Plant[];
  loading: boolean;
  error: any;
}

export const initialState: PlantState = {
  plants: [],
  loading: false,
  error: null,
};

export const plantReducer = createReducer(
  initialState,
  on(plantActions.loadPlants, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(plantActions.loadPlantsSuccess, (state, { plants }) => ({
    ...state,
    plants: [...plants].sort((a, b) =>
      (a.sapDescription ?? '').localeCompare(b.sapDescription ?? ''),
    ),
    loading: false,
    error: null,
  })),
  on(plantActions.loadPlantsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);
